// @flow
import * as React from 'react';
import distanceInWordsStrict from 'date-fns/distance_in_words_strict';
import type { UGCSection, UGCSectionHeaderComponent } from './UGCSection';
import UserGeneratedTextContainer from './UserGeneratedTextContainer';
import InstagramLogo from 'components/Icons/InstagramLogo';
import styles from './MediaSection.scss';

const Header: UGCSectionHeaderComponent = () => null;

const getRelatedContent = (ugc, options) => {
  const { caption, author, created_date } = ugc;

  if (!caption) {
    return null;
  }

  return [
    <div className="mv4 ph4 flex" key="caption2">
      <InstagramLogo className="w2 h2 mr2 mv1 flex-none" />
      <div className="flex flex-column">
        <strong>
          <UserGeneratedTextContainer data-key="author" text={author} />
        </strong>
        <span className="gray">
          <UserGeneratedTextContainer data-key="caption" text={caption} />
        </span>
        <small data-key="created_date" className="lh-copy silver">
          {formatDate(created_date)}
        </small>
      </div>
    </div>,
  ];
};

const provideCollapsedContent = (ugc, options, collapsedContentProps) => (
  <div />
);

export const SocialCollectionSection: UGCSection = {
  Header,
  getRelatedContent,
  provideCollapsedContent,
  Content: props => {
    const { urlSet, caption, ugc_archetype } = props.ugc;

    return (
      <div className="ma4">
        {ugc_archetype === 'Video' ? (
          <video
            height="auto"
            width="100%"
            controls
            className={styles.mediaSectionNativeVideo}
          >
            <source src={urlSet.raw} type="video/mp4" />
          </video>
        ) : (
          <img
            src={urlSet.large}
            alt={caption}
            className={styles.mediaSectionImage}
          />
        )}
      </div>
    );
  },
};

function formatDate(isoDateString) {
  return distanceInWordsStrict(new Date().toISOString(), isoDateString, {
    addSuffix: true,
  });
}

export default SocialCollectionSection;



// WEBPACK FOOTER //
// ./src/components/ContentSection/SocialCollectionSection.js